module.exports = __webpack_public_path__ + "img/crediCodeImg_c.0eb08ac6.png";